import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transformer-dashboard',
  templateUrl: './transformer-dashboard.component.html',
  styleUrls: ['./transformer-dashboard.component.scss']
})
export class TransformerDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
